import React from "react";

function Allowance() {
  return (
    <section className="bg-black/90 p-20">
      <div className="container mx-auto">
        <h2 className="text-3xl font-extrabold text-white text-center mb-6">
          Why Government Would Allow Us
        </h2>
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-yellow-400">Economic Benefits:</h3>
          <p className="text-gray-300">
            Decreasing charges for emergency bookings and enabling ticket resale fosters economic activity within the transportation sector, benefiting both travelers and service providers.
          </p>

          <h3 className="text-xl font-semibold text-yellow-400">Enhanced Transparency and Accountability:</h3>
          <p className="text-gray-300">
            Decreasing charges for emergency bookings and enabling ticket resale fosters economic activity within the transportation sector, benefiting both travelers and service providers.
          </p>

          <h3 className="text-xl font-semibold text-yellow-400">Support for Emergency Situations:</h3>
          <p className="text-gray-300">
            Decreasing charges for emergency bookings and enabling ticket resale fosters economic activity within the transportation sector, benefiting both travelers and service providers.
          </p>

          <h3 className="text-xl font-semibold text-yellow-400">Efficient Ticket Management:</h3>
          <p className="text-gray-300">
            The smart contract acts as an efficient intermediary between users and government portals, streamlining the ticketing process and reducing administrative burden for government agencies.
          </p>

          <h3 className="text-xl font-semibold text-yellow-400">Promotion of Public Welfare:</h3>
          <p className="text-gray-300">
            Real-time waiting list and ticket exchange features contribute to a more inclusive and accessible transportation system, aligning with government goals of promoting public welfare and convenience.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Allowance;
